import { PostStatus } from '@dill/dill-shared';
import { CheckCircle, Clock, WarningCircle, XCircle, Spinner } from 'phosphor-react';

const statusConfig: Record<
  PostStatus,
  { label: string; icon: React.ReactNode; className: string }
> = {
  SUCCESSFUL: {
    label: 'Successful',
    icon: <CheckCircle size={14} weight="fill" />,
    className: 'bg-emerald-50 text-emerald-700 ring-emerald-600/20',
  },
  PENDING: {
    label: 'Pending',
    icon: <Clock size={14} weight="fill" />,
    className: 'bg-amber-50 text-amber-700 ring-amber-600/20',
  },
  POSTING: {
    label: 'Posting',
    icon: <Spinner size={14} weight="bold" className="animate-spin" />,
    className: 'bg-blue-50 text-blue-700 ring-blue-600/20',
  },
  // Orange, deliberately between amber Pending and red Failed: some of this receipt's payments are
  // correctly in the ERP and cannot be taken back, so it is neither in flight nor a clean failure.
  PARTIAL: {
    label: 'Partly posted',
    icon: <WarningCircle size={14} weight="fill" />,
    className: 'bg-orange-50 text-orange-700 ring-orange-600/20',
  },
  FAILED: {
    label: 'Failed',
    icon: <XCircle size={14} weight="fill" />,
    className: 'bg-red-50 text-red-700 ring-red-600/20',
  },
};

interface PostStatusBadgeProps {
  status: PostStatus;
  /** The reason, for a status that has one. Shown on hover, as `DepositStatusBadge` does. */
  title?: string | null;
}

export const PostStatusBadge = ({ status, title }: PostStatusBadgeProps) => {
  const config = statusConfig[status];
  return (
    <span
      title={title ?? undefined}
      className={
        'inline-flex items-center gap-1 px-2.5 py-1 rounded-full text-xs font-medium ring-1 ring-inset ' +
        config.className
      }>
      {config.icon}
      {config.label}
    </span>
  );
};
